module.exports = __webpack_public_path__ + "static/media/move.394db900.svg";